import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'
// import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const tbdService = {
  getTbds: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/admin/tbd`, getAxiosOptions(user))).data
  },

  createOrUpdateTbd: async (user, tbdData) => {
    return (await axios.post(`${NODE_BASE_URL}/admin/tbd`, tbdData, getAxiosOptions(user))).data
  },

  deleteTbd: async (user, tbd_id) => {
    return (await axios.delete(`${NODE_BASE_URL}/admin/tbd/${tbd_id}`, getAxiosOptions(user))).data
  },
}
